// import React from "react";
// import { Modal, Button } from "react-bootstrap";
// import PrimaryOutLineButton from './PrimaryOutLineButton';

// const SimpleModal = ({ isOpen, onClose, title, description }) => {
//   return (
//     <Modal show={isOpen} onHide={onClose} backdrop="static" keyboard={false} centered>
//       <Modal.Header>
//         <Modal.Title>{title}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>{description}</Modal.Body>
//       <Modal.Footer>
//         <Button variant="primary" onClick={onClose}>Okay</Button>
//         {/* <PrimaryOutLineButton outlinebuttonText={outlinebuttonText} onClick={onClick} /> */}
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default SimpleModal;

// import React from "react";
// import { Modal, Button } from "react-bootstrap";

// const SimpleModal = ({ 
//   isOpen, 
//   onClose, 
//   title, 
//   description, 
//   type = "info", 
//   onYes,
//   onNo
// }) => {
//   return (
//     <Modal show={isOpen} onHide={onClose} backdrop="static" keyboard={false} centered>
//       <Modal.Header>
//         <Modal.Title>{title}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>{description}</Modal.Body>
//       <Modal.Footer>
//         {type === "confirmation" ? (
//           <>
//             <Button variant="danger" onClick={onNo}>No</Button>
//             <Button variant="success" onClick={onYes}>Yes</Button>
//           </>
//         ) : (
//           <Button variant="primary" onClick={onClose}>Okay</Button>
//         )}
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default SimpleModal;

import React from "react";
import { Modal, Button } from "react-bootstrap";

const SimpleModal = ({ 
  isOpen, 
  onClose, 
  title, 
  description, 
  type = "info", 
  onYes,
  onNo
}) => {
  return (
    <Modal show={isOpen} onHide={onClose} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        {type === "confirmation" ? (
          <>
            <Button variant="danger" onClick={onNo}>No</Button>
            <Button variant="success" onClick={onYes}>Yes</Button>
          </>
        ) : (
          <Button variant="primary" onClick={onClose}>Okay</Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SimpleModal;

